import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _9fbbdb1c = () => interopDefault(import('../pages/banners/index.vue' /* webpackChunkName: "pages/banners/index" */))
const _3bf4566a = () => interopDefault(import('../pages/bol-screenshots/index.vue' /* webpackChunkName: "pages/bol-screenshots/index" */))
const _d73e33a6 = () => interopDefault(import('../pages/card-orders/index.vue' /* webpackChunkName: "pages/card-orders/index" */))
const _5259940e = () => interopDefault(import('../pages/cards/index.vue' /* webpackChunkName: "pages/cards/index" */))
const _4866b8d5 = () => interopDefault(import('../pages/cashback-setup/index.vue' /* webpackChunkName: "pages/cashback-setup/index" */))
const _22f179ff = () => interopDefault(import('../pages/cashback-setup/index/legal.vue' /* webpackChunkName: "pages/cashback-setup/index/legal" */))
const _736d976e = () => interopDefault(import('../pages/cashback-setup/index/private.vue' /* webpackChunkName: "pages/cashback-setup/index/private" */))
const _76e9bc71 = () => interopDefault(import('../pages/client-requests/index.vue' /* webpackChunkName: "pages/client-requests/index" */))
const _176929f6 = () => interopDefault(import('../pages/country-groups/index.vue' /* webpackChunkName: "pages/country-groups/index" */))
const _3646b13f = () => interopDefault(import('../pages/country-groups/index/_categoryId.vue' /* webpackChunkName: "pages/country-groups/index/_categoryId" */))
const _5c2c71ea = () => interopDefault(import('../pages/custom-requests/index.vue' /* webpackChunkName: "pages/custom-requests/index" */))
const _4bdb2302 = () => interopDefault(import('../pages/czcb-swifts/index.vue' /* webpackChunkName: "pages/czcb-swifts/index" */))
const _61cee5ff = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _7063ed90 = () => interopDefault(import('../pages/fees/index.vue' /* webpackChunkName: "pages/fees/index" */))
const _5fc17dc6 = () => interopDefault(import('../pages/fees/index/recurring.vue' /* webpackChunkName: "pages/fees/index/recurring" */))
const _208527f2 = () => interopDefault(import('../pages/fees/index/transactional.vue' /* webpackChunkName: "pages/fees/index/transactional" */))
const _d3203ec6 = () => interopDefault(import('../pages/fin-channels/index.vue' /* webpackChunkName: "pages/fin-channels/index" */))
const _70c40e80 = () => interopDefault(import('../pages/forex-requests/index.vue' /* webpackChunkName: "pages/forex-requests/index" */))
const _318da617 = () => interopDefault(import('../pages/forex-setup/index.vue' /* webpackChunkName: "pages/forex-setup/index" */))
const _da665880 = () => interopDefault(import('../pages/forex-setup/index/limits.vue' /* webpackChunkName: "pages/forex-setup/index/limits" */))
const _70cadd9b = () => interopDefault(import('../pages/forex-setup/index/rates.vue' /* webpackChunkName: "pages/forex-setup/index/rates" */))
const _21ab7bd2 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _17cce15a = () => interopDefault(import('../pages/notifications/index.vue' /* webpackChunkName: "pages/notifications/index" */))
const _7cfeb552 = () => interopDefault(import('../pages/payment-orders/index.vue' /* webpackChunkName: "pages/payment-orders/index" */))
const _754b0a90 = () => interopDefault(import('../pages/payments/index.vue' /* webpackChunkName: "pages/payments/index" */))
const _7aec803e = () => interopDefault(import('../pages/rates/index.vue' /* webpackChunkName: "pages/rates/index" */))
const _05a7df3e = () => interopDefault(import('../pages/referral-campaigns/index.vue' /* webpackChunkName: "pages/referral-campaigns/index" */))
const _76c2fd3e = () => interopDefault(import('../pages/referrals/index.vue' /* webpackChunkName: "pages/referrals/index" */))
const _feed4cd8 = () => interopDefault(import('../pages/savings-setup/index.vue' /* webpackChunkName: "pages/savings-setup/index" */))
const _583d7840 = () => interopDefault(import('../pages/savings-setup/index/deposits.vue' /* webpackChunkName: "pages/savings-setup/index/deposits" */))
const _316d999e = () => interopDefault(import('../pages/savings-setup/index/savings-account.vue' /* webpackChunkName: "pages/savings-setup/index/savings-account" */))
const _5333b550 = () => interopDefault(import('../pages/subscription-setup/index.vue' /* webpackChunkName: "pages/subscription-setup/index" */))
const _0c776bf0 = () => interopDefault(import('../pages/swift-message-orders/index.vue' /* webpackChunkName: "pages/swift-message-orders/index" */))
const _afa72fde = () => interopDefault(import('../pages/swift-messages/index.vue' /* webpackChunkName: "pages/swift-messages/index" */))
const _9c4fe412 = () => interopDefault(import('../pages/target2-participants/index.vue' /* webpackChunkName: "pages/target2-participants/index" */))
const _57221f1a = () => interopDefault(import('../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _0e1d317e = () => interopDefault(import('../pages/working-days/index.vue' /* webpackChunkName: "pages/working-days/index" */))
const _7bd4868c = () => interopDefault(import('../pages/banners/create.vue' /* webpackChunkName: "pages/banners/create" */))
const _1f702a31 = () => interopDefault(import('../pages/card-orders/create.vue' /* webpackChunkName: "pages/card-orders/create" */))
const _e3fbc726 = () => interopDefault(import('../pages/client-requests/create.vue' /* webpackChunkName: "pages/client-requests/create" */))
const _11b82afe = () => interopDefault(import('../pages/czcb-swifts/upload.vue' /* webpackChunkName: "pages/czcb-swifts/upload" */))
const _e49c053e = () => interopDefault(import('../pages/fees/groups/index.vue' /* webpackChunkName: "pages/fees/groups/index" */))
const _56b30850 = () => interopDefault(import('../pages/notifications/upload.vue' /* webpackChunkName: "pages/notifications/upload" */))
const _42294c77 = () => interopDefault(import('../pages/open-banking/applications.vue' /* webpackChunkName: "pages/open-banking/applications" */))
const _a4c0a5e2 = () => interopDefault(import('../pages/open-banking/institutions.vue' /* webpackChunkName: "pages/open-banking/institutions" */))
const _096f1f81 = () => interopDefault(import('../pages/open-banking/payments.vue' /* webpackChunkName: "pages/open-banking/payments" */))
const _2ad1a0b8 = () => interopDefault(import('../pages/payments/errors/index.vue' /* webpackChunkName: "pages/payments/errors/index" */))
const _1db64b28 = () => interopDefault(import('../pages/payments/not-settled/index.vue' /* webpackChunkName: "pages/payments/not-settled/index" */))
const _8820add4 = () => interopDefault(import('../pages/payments/on-hold/index.vue' /* webpackChunkName: "pages/payments/on-hold/index" */))
const _cbfbf078 = () => interopDefault(import('../pages/payments/on-hold-integrator/index.vue' /* webpackChunkName: "pages/payments/on-hold-integrator/index" */))
const _c2926b80 = () => interopDefault(import('../pages/payments/pending/index.vue' /* webpackChunkName: "pages/payments/pending/index" */))
const _2a1159c6 = () => interopDefault(import('../pages/payments/pending-cancellation/index.vue' /* webpackChunkName: "pages/payments/pending-cancellation/index" */))
const _017d8706 = () => interopDefault(import('../pages/payments/postponed-swift/index.vue' /* webpackChunkName: "pages/payments/postponed-swift/index" */))
const _765cde98 = () => interopDefault(import('../pages/payments/unassigned/index.vue' /* webpackChunkName: "pages/payments/unassigned/index" */))
const _184e4db6 = () => interopDefault(import('../pages/payments/unidentified-topups/index.vue' /* webpackChunkName: "pages/payments/unidentified-topups/index" */))
const _d2e1a430 = () => interopDefault(import('../pages/payments/verification/index.vue' /* webpackChunkName: "pages/payments/verification/index" */))
const _9dd73c3c = () => interopDefault(import('../pages/profile-customers/create.vue' /* webpackChunkName: "pages/profile-customers/create" */))
const _43b68fea = () => interopDefault(import('../pages/profile-customers/import.vue' /* webpackChunkName: "pages/profile-customers/import" */))
const _7fde04c8 = () => interopDefault(import('../pages/profiles/legal.vue' /* webpackChunkName: "pages/profiles/legal" */))
const _ccd376b4 = () => interopDefault(import('../pages/profiles/private.vue' /* webpackChunkName: "pages/profiles/private" */))
const _33959d6a = () => interopDefault(import('../pages/profiles/remittance.vue' /* webpackChunkName: "pages/profiles/remittance" */))
const _51ef5980 = () => interopDefault(import('../pages/referral-campaigns/create.vue' /* webpackChunkName: "pages/referral-campaigns/create" */))
const _abab4664 = () => interopDefault(import('../pages/swift-message-orders/create.vue' /* webpackChunkName: "pages/swift-message-orders/create" */))
const _50c45e2c = () => interopDefault(import('../pages/target2-participants/upload.vue' /* webpackChunkName: "pages/target2-participants/upload" */))
const _335aae40 = () => interopDefault(import('../pages/fees/groups/create/index.vue' /* webpackChunkName: "pages/fees/groups/create/index" */))
const _071014fb = () => interopDefault(import('../pages/fees/recurring/create/index.vue' /* webpackChunkName: "pages/fees/recurring/create/index" */))
const _736988cf = () => interopDefault(import('../pages/fees/transactional/create/index.vue' /* webpackChunkName: "pages/fees/transactional/create/index" */))
const _4adc8a40 = () => interopDefault(import('../pages/payments/create/fee/index.vue' /* webpackChunkName: "pages/payments/create/fee/index" */))
const _0fc8da94 = () => interopDefault(import('../pages/payments/create/forex/index.vue' /* webpackChunkName: "pages/payments/create/forex/index" */))
const _0b4d79d9 = () => interopDefault(import('../pages/payments/create/internal/index.vue' /* webpackChunkName: "pages/payments/create/internal/index" */))
const _4debd5ac = () => interopDefault(import('../pages/payments/create/topup/index.vue' /* webpackChunkName: "pages/payments/create/topup/index" */))
const _40d70d91 = () => interopDefault(import('../pages/payments/create/withdrawal/index.vue' /* webpackChunkName: "pages/payments/create/withdrawal/index" */))
const _cfea788c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _ff16b942 = () => interopDefault(import('../pages/channel-setup/channel-route/_channelRouteId/index.vue' /* webpackChunkName: "pages/channel-setup/channel-route/_channelRouteId/index" */))
const _92c90068 = () => interopDefault(import('../pages/fees/groups/_id/index.vue' /* webpackChunkName: "pages/fees/groups/_id/index" */))
const _1434847a = () => interopDefault(import('../pages/fees/recurring/_recurringFeeId/index.vue' /* webpackChunkName: "pages/fees/recurring/_recurringFeeId/index" */))
const _14338b45 = () => interopDefault(import('../pages/fees/transactional/_transactionFeeId/index.vue' /* webpackChunkName: "pages/fees/transactional/_transactionFeeId/index" */))
const _0206180d = () => interopDefault(import('../pages/channel-setup/channel-route/_channelRouteId/edit.vue' /* webpackChunkName: "pages/channel-setup/channel-route/_channelRouteId/edit" */))
const _1c8b7a00 = () => interopDefault(import('../pages/fees/groups/_id/edit.vue' /* webpackChunkName: "pages/fees/groups/_id/edit" */))
const _4aa93895 = () => interopDefault(import('../pages/fees/recurring/_recurringFeeId/edit/index.vue' /* webpackChunkName: "pages/fees/recurring/_recurringFeeId/edit/index" */))
const _0985b8aa = () => interopDefault(import('../pages/fees/transactional/_transactionFeeId/edit/index.vue' /* webpackChunkName: "pages/fees/transactional/_transactionFeeId/edit/index" */))
const _f504d3fc = () => interopDefault(import('../pages/card-orders/_orderId/index.vue' /* webpackChunkName: "pages/card-orders/_orderId/index" */))
const _41e266a9 = () => interopDefault(import('../pages/channel-setup/_license/index.vue' /* webpackChunkName: "pages/channel-setup/_license/index" */))
const _382c1634 = () => interopDefault(import('../pages/client-requests/_clientRequestId/index.vue' /* webpackChunkName: "pages/client-requests/_clientRequestId/index" */))
const _4607e0a5 = () => interopDefault(import('../pages/custom-requests/_requestId/index.vue' /* webpackChunkName: "pages/custom-requests/_requestId/index" */))
const _5650fd7c = () => interopDefault(import('../pages/deposits/_depositId.vue' /* webpackChunkName: "pages/deposits/_depositId" */))
const _15ce1bca = () => interopDefault(import('../pages/payment-orders/_paymentOrderId/index.vue' /* webpackChunkName: "pages/payment-orders/_paymentOrderId/index" */))
const _3eaf364c = () => interopDefault(import('../pages/payments/_paymentId.vue' /* webpackChunkName: "pages/payments/_paymentId" */))
const _30011ea2 = () => interopDefault(import('../pages/payments/_paymentId/activity.vue' /* webpackChunkName: "pages/payments/_paymentId/activity" */))
const _0971f3a5 = () => interopDefault(import('../pages/payments/_paymentId/general.vue' /* webpackChunkName: "pages/payments/_paymentId/general" */))
const _a46dcb82 = () => interopDefault(import('../pages/payments/_paymentId/operations.vue' /* webpackChunkName: "pages/payments/_paymentId/operations" */))
const _8cded176 = () => interopDefault(import('../pages/profile-customers/_customerId/index.vue' /* webpackChunkName: "pages/profile-customers/_customerId/index" */))
const _8d2e8d5c = () => interopDefault(import('../pages/profiles/_profileId.vue' /* webpackChunkName: "pages/profiles/_profileId" */))
const _35f1b09a = () => interopDefault(import('../pages/profiles/_profileId/accounts.vue' /* webpackChunkName: "pages/profiles/_profileId/accounts" */))
const _0403a25c = () => interopDefault(import('../pages/profiles/_profileId/activity.vue' /* webpackChunkName: "pages/profiles/_profileId/activity" */))
const _075004f6 = () => interopDefault(import('../pages/profiles/_profileId/card-orders.vue' /* webpackChunkName: "pages/profiles/_profileId/card-orders" */))
const _4bb455c0 = () => interopDefault(import('../pages/profiles/_profileId/card-topup.vue' /* webpackChunkName: "pages/profiles/_profileId/card-topup" */))
const _d750ef34 = () => interopDefault(import('../pages/profiles/_profileId/cards.vue' /* webpackChunkName: "pages/profiles/_profileId/cards" */))
const _7e7ea067 = () => interopDefault(import('../pages/profiles/_profileId/cashback.vue' /* webpackChunkName: "pages/profiles/_profileId/cashback" */))
const _3e1966d8 = () => interopDefault(import('../pages/profiles/_profileId/customers.vue' /* webpackChunkName: "pages/profiles/_profileId/customers" */))
const _3ad848d8 = () => interopDefault(import('../pages/profiles/_profileId/esim-reissue.vue' /* webpackChunkName: "pages/profiles/_profileId/esim-reissue" */))
const _27e766ec = () => interopDefault(import('../pages/profiles/_profileId/features.vue' /* webpackChunkName: "pages/profiles/_profileId/features" */))
const _1b6d0f0c = () => interopDefault(import('../pages/profiles/_profileId/fees.vue' /* webpackChunkName: "pages/profiles/_profileId/fees" */))
const _2a6574ef = () => interopDefault(import('../pages/profiles/_profileId/forex-setup.vue' /* webpackChunkName: "pages/profiles/_profileId/forex-setup" */))
const _63e74b20 = () => interopDefault(import('../pages/profiles/_profileId/open-banking.vue' /* webpackChunkName: "pages/profiles/_profileId/open-banking" */))
const _2a025599 = () => interopDefault(import('../pages/profiles/_profileId/payment-orders.vue' /* webpackChunkName: "pages/profiles/_profileId/payment-orders" */))
const _f34b010c = () => interopDefault(import('../pages/profiles/_profileId/payments.vue' /* webpackChunkName: "pages/profiles/_profileId/payments" */))
const _1cb0a6de = () => interopDefault(import('../pages/profiles/_profileId/requests.vue' /* webpackChunkName: "pages/profiles/_profileId/requests" */))
const _7d23a6f4 = () => interopDefault(import('../pages/profiles/_profileId/restrictions.vue' /* webpackChunkName: "pages/profiles/_profileId/restrictions" */))
const _4856b808 = () => interopDefault(import('../pages/profiles/_profileId/savings.vue' /* webpackChunkName: "pages/profiles/_profileId/savings" */))
const _7a707d20 = () => interopDefault(import('../pages/profiles/_profileId/settings.vue' /* webpackChunkName: "pages/profiles/_profileId/settings" */))
const _91a156ea = () => interopDefault(import('../pages/profiles/_profileId/users.vue' /* webpackChunkName: "pages/profiles/_profileId/users" */))
const _498e5a5a = () => interopDefault(import('../pages/profiles/_profileId/watchdog.vue' /* webpackChunkName: "pages/profiles/_profileId/watchdog" */))
const _4ae7f54e = () => interopDefault(import('../pages/referral-campaigns/_campaignId/index.vue' /* webpackChunkName: "pages/referral-campaigns/_campaignId/index" */))
const _79c8ac41 = () => interopDefault(import('../pages/savings-accounts/_savingsAccountId.vue' /* webpackChunkName: "pages/savings-accounts/_savingsAccountId" */))
const _47c4a49a = () => interopDefault(import('../pages/savings-accounts/_savingsAccountId/general.vue' /* webpackChunkName: "pages/savings-accounts/_savingsAccountId/general" */))
const _50f60c93 = () => interopDefault(import('../pages/savings-accounts/_savingsAccountId/transactions.vue' /* webpackChunkName: "pages/savings-accounts/_savingsAccountId/transactions" */))
const _b5c1b9ea = () => interopDefault(import('../pages/swift-message-orders/_swiftMessageOrderId/index.vue' /* webpackChunkName: "pages/swift-message-orders/_swiftMessageOrderId/index" */))
const _6cf29192 = () => interopDefault(import('../pages/swift-messages/_messageCloudReference/index.vue' /* webpackChunkName: "pages/swift-messages/_messageCloudReference/index" */))
const _9f8eb47a = () => interopDefault(import('../pages/banners/_bannerId/edit.vue' /* webpackChunkName: "pages/banners/_bannerId/edit" */))
const _2e97df10 = () => interopDefault(import('../pages/card-orders/_orderId/card.vue' /* webpackChunkName: "pages/card-orders/_orderId/card" */))
const _40dfdb44 = () => interopDefault(import('../pages/card-orders/_orderId/card/activity.vue' /* webpackChunkName: "pages/card-orders/_orderId/card/activity" */))
const _3f41fcf9 = () => interopDefault(import('../pages/card-orders/_orderId/card/data.vue' /* webpackChunkName: "pages/card-orders/_orderId/card/data" */))
const _b1bf7e7a = () => interopDefault(import('../pages/card-orders/_orderId/card/delivery.vue' /* webpackChunkName: "pages/card-orders/_orderId/card/delivery" */))
const _025840a7 = () => interopDefault(import('../pages/card-orders/_orderId/card/limits.vue' /* webpackChunkName: "pages/card-orders/_orderId/card/limits" */))
const _e2da75ec = () => interopDefault(import('../pages/card-orders/_orderId/edit.vue' /* webpackChunkName: "pages/card-orders/_orderId/edit" */))
const _c36f5304 = () => interopDefault(import('../pages/card-orders/_orderId/order.vue' /* webpackChunkName: "pages/card-orders/_orderId/order" */))
const _310416b0 = () => interopDefault(import('../pages/card-orders/_orderId/order/activity.vue' /* webpackChunkName: "pages/card-orders/_orderId/order/activity" */))
const _2c0e0b6a = () => interopDefault(import('../pages/card-orders/_orderId/order/data.vue' /* webpackChunkName: "pages/card-orders/_orderId/order/data" */))
const _221eb935 = () => interopDefault(import('../pages/channel-setup/_license/create.vue' /* webpackChunkName: "pages/channel-setup/_license/create" */))
const _9d6de132 = () => interopDefault(import('../pages/profile-customers/_customerId/edit.vue' /* webpackChunkName: "pages/profile-customers/_customerId/edit" */))
const _cdd9d2fc = () => interopDefault(import('../pages/profile-customers/_customerId/view.vue' /* webpackChunkName: "pages/profile-customers/_customerId/view" */))
const _0ebd98f6 = () => interopDefault(import('../pages/profile-customers/_customerId/view/index.vue' /* webpackChunkName: "pages/profile-customers/_customerId/view/index" */))
const _c111c9a8 = () => interopDefault(import('../pages/profile-customers/_customerId/view/activity.vue' /* webpackChunkName: "pages/profile-customers/_customerId/view/activity" */))
const _78653ddb = () => interopDefault(import('../pages/profile-customers/_customerId/view/general.vue' /* webpackChunkName: "pages/profile-customers/_customerId/view/general" */))
const _7a44e25a = () => interopDefault(import('../pages/referral-campaigns/_campaignId/edit.vue' /* webpackChunkName: "pages/referral-campaigns/_campaignId/edit" */))
const _b7d2e7b0 = () => interopDefault(import('../pages/swift-messages/_swiftMessageId/reply.vue' /* webpackChunkName: "pages/swift-messages/_swiftMessageId/reply" */))
const _62985531 = () => interopDefault(import('../pages/swift-messages/_swiftMessageId/v2/index.vue' /* webpackChunkName: "pages/swift-messages/_swiftMessageId/v2/index" */))
const _466b3e0a = () => interopDefault(import('../pages/channel-setup/_license/_currency/index.vue' /* webpackChunkName: "pages/channel-setup/_license/_currency/index" */))
const _6c5eeca4 = () => interopDefault(import('../pages/channel-setup/_license/_currency/index/activity.vue' /* webpackChunkName: "pages/channel-setup/_license/_currency/index/activity" */))
const _2b230bb8 = () => interopDefault(import('../pages/channel-setup/_license/_currency/index/settings.vue' /* webpackChunkName: "pages/channel-setup/_license/_currency/index/settings" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/banners",
    component: _9fbbdb1c,
    name: "banners"
  }, {
    path: "/bol-screenshots",
    component: _3bf4566a,
    name: "bol-screenshots"
  }, {
    path: "/card-orders",
    component: _d73e33a6,
    name: "card-orders"
  }, {
    path: "/cards",
    component: _5259940e,
    name: "cards"
  }, {
    path: "/cashback-setup",
    component: _4866b8d5,
    name: "cashback-setup",
    children: [{
      path: "legal",
      component: _22f179ff,
      name: "cashback-setup-index-legal"
    }, {
      path: "private",
      component: _736d976e,
      name: "cashback-setup-index-private"
    }]
  }, {
    path: "/client-requests",
    component: _76e9bc71,
    name: "client-requests"
  }, {
    path: "/country-groups",
    component: _176929f6,
    name: "country-groups",
    children: [{
      path: ":categoryId?",
      component: _3646b13f,
      name: "country-groups-index-categoryId"
    }]
  }, {
    path: "/custom-requests",
    component: _5c2c71ea,
    name: "custom-requests"
  }, {
    path: "/czcb-swifts",
    component: _4bdb2302,
    name: "czcb-swifts"
  }, {
    path: "/dashboard",
    component: _61cee5ff,
    name: "dashboard"
  }, {
    path: "/fees",
    component: _7063ed90,
    name: "fees",
    children: [{
      path: "recurring",
      component: _5fc17dc6,
      name: "fees-index-recurring"
    }, {
      path: "transactional",
      component: _208527f2,
      name: "fees-index-transactional"
    }]
  }, {
    path: "/fin-channels",
    component: _d3203ec6,
    name: "fin-channels"
  }, {
    path: "/forex-requests",
    component: _70c40e80,
    name: "forex-requests"
  }, {
    path: "/forex-setup",
    component: _318da617,
    name: "forex-setup",
    children: [{
      path: "limits",
      component: _da665880,
      name: "forex-setup-index-limits"
    }, {
      path: "rates",
      component: _70cadd9b,
      name: "forex-setup-index-rates"
    }]
  }, {
    path: "/logout",
    component: _21ab7bd2,
    name: "logout"
  }, {
    path: "/notifications",
    component: _17cce15a,
    name: "notifications"
  }, {
    path: "/payment-orders",
    component: _7cfeb552,
    name: "payment-orders"
  }, {
    path: "/payments",
    component: _754b0a90,
    name: "payments"
  }, {
    path: "/rates",
    component: _7aec803e,
    name: "rates"
  }, {
    path: "/referral-campaigns",
    component: _05a7df3e,
    name: "referral-campaigns"
  }, {
    path: "/referrals",
    component: _76c2fd3e,
    name: "referrals"
  }, {
    path: "/savings-setup",
    component: _feed4cd8,
    name: "savings-setup",
    children: [{
      path: "deposits",
      component: _583d7840,
      name: "savings-setup-index-deposits"
    }, {
      path: "savings-account",
      component: _316d999e,
      name: "savings-setup-index-savings-account"
    }]
  }, {
    path: "/subscription-setup",
    component: _5333b550,
    name: "subscription-setup"
  }, {
    path: "/swift-message-orders",
    component: _0c776bf0,
    name: "swift-message-orders"
  }, {
    path: "/swift-messages",
    component: _afa72fde,
    name: "swift-messages"
  }, {
    path: "/target2-participants",
    component: _9c4fe412,
    name: "target2-participants"
  }, {
    path: "/users",
    component: _57221f1a,
    name: "users"
  }, {
    path: "/working-days",
    component: _0e1d317e,
    name: "working-days"
  }, {
    path: "/banners/create",
    component: _7bd4868c,
    name: "banners-create"
  }, {
    path: "/card-orders/create",
    component: _1f702a31,
    name: "card-orders-create"
  }, {
    path: "/client-requests/create",
    component: _e3fbc726,
    name: "client-requests-create"
  }, {
    path: "/czcb-swifts/upload",
    component: _11b82afe,
    name: "czcb-swifts-upload"
  }, {
    path: "/fees/groups",
    component: _e49c053e,
    name: "fees-groups"
  }, {
    path: "/notifications/upload",
    component: _56b30850,
    name: "notifications-upload"
  }, {
    path: "/open-banking/applications",
    component: _42294c77,
    name: "open-banking-applications"
  }, {
    path: "/open-banking/institutions",
    component: _a4c0a5e2,
    name: "open-banking-institutions"
  }, {
    path: "/open-banking/payments",
    component: _096f1f81,
    name: "open-banking-payments"
  }, {
    path: "/payments/errors",
    component: _2ad1a0b8,
    name: "payments-errors"
  }, {
    path: "/payments/not-settled",
    component: _1db64b28,
    name: "payments-not-settled"
  }, {
    path: "/payments/on-hold",
    component: _8820add4,
    name: "payments-on-hold"
  }, {
    path: "/payments/on-hold-integrator",
    component: _cbfbf078,
    name: "payments-on-hold-integrator"
  }, {
    path: "/payments/pending",
    component: _c2926b80,
    name: "payments-pending"
  }, {
    path: "/payments/pending-cancellation",
    component: _2a1159c6,
    name: "payments-pending-cancellation"
  }, {
    path: "/payments/postponed-swift",
    component: _017d8706,
    name: "payments-postponed-swift"
  }, {
    path: "/payments/unassigned",
    component: _765cde98,
    name: "payments-unassigned"
  }, {
    path: "/payments/unidentified-topups",
    component: _184e4db6,
    name: "payments-unidentified-topups"
  }, {
    path: "/payments/verification",
    component: _d2e1a430,
    name: "payments-verification"
  }, {
    path: "/profile-customers/create",
    component: _9dd73c3c,
    name: "profile-customers-create"
  }, {
    path: "/profile-customers/import",
    component: _43b68fea,
    name: "profile-customers-import"
  }, {
    path: "/profiles/legal",
    component: _7fde04c8,
    name: "profiles-legal"
  }, {
    path: "/profiles/private",
    component: _ccd376b4,
    name: "profiles-private"
  }, {
    path: "/profiles/remittance",
    component: _33959d6a,
    name: "profiles-remittance"
  }, {
    path: "/referral-campaigns/create",
    component: _51ef5980,
    name: "referral-campaigns-create"
  }, {
    path: "/swift-message-orders/create",
    component: _abab4664,
    name: "swift-message-orders-create"
  }, {
    path: "/target2-participants/upload",
    component: _50c45e2c,
    name: "target2-participants-upload"
  }, {
    path: "/fees/groups/create",
    component: _335aae40,
    name: "fees-groups-create"
  }, {
    path: "/fees/recurring/create",
    component: _071014fb,
    name: "fees-recurring-create"
  }, {
    path: "/fees/transactional/create",
    component: _736988cf,
    name: "fees-transactional-create"
  }, {
    path: "/payments/create/fee",
    component: _4adc8a40,
    name: "payments-create-fee"
  }, {
    path: "/payments/create/forex",
    component: _0fc8da94,
    name: "payments-create-forex"
  }, {
    path: "/payments/create/internal",
    component: _0b4d79d9,
    name: "payments-create-internal"
  }, {
    path: "/payments/create/topup",
    component: _4debd5ac,
    name: "payments-create-topup"
  }, {
    path: "/payments/create/withdrawal",
    component: _40d70d91,
    name: "payments-create-withdrawal"
  }, {
    path: "/",
    component: _cfea788c,
    name: "index"
  }, {
    path: "/channel-setup/channel-route/:channelRouteId",
    component: _ff16b942,
    name: "channel-setup-channel-route-channelRouteId"
  }, {
    path: "/fees/groups/:id",
    component: _92c90068,
    name: "fees-groups-id"
  }, {
    path: "/fees/recurring/:recurringFeeId",
    component: _1434847a,
    name: "fees-recurring-recurringFeeId"
  }, {
    path: "/fees/transactional/:transactionFeeId",
    component: _14338b45,
    name: "fees-transactional-transactionFeeId"
  }, {
    path: "/channel-setup/channel-route/:channelRouteId?/edit",
    component: _0206180d,
    name: "channel-setup-channel-route-channelRouteId-edit"
  }, {
    path: "/fees/groups/:id/edit",
    component: _1c8b7a00,
    name: "fees-groups-id-edit"
  }, {
    path: "/fees/recurring/:recurringFeeId?/edit",
    component: _4aa93895,
    name: "fees-recurring-recurringFeeId-edit"
  }, {
    path: "/fees/transactional/:transactionFeeId?/edit",
    component: _0985b8aa,
    name: "fees-transactional-transactionFeeId-edit"
  }, {
    path: "/card-orders/:orderId",
    component: _f504d3fc,
    name: "card-orders-orderId"
  }, {
    path: "/channel-setup/:license",
    component: _41e266a9,
    name: "channel-setup-license"
  }, {
    path: "/client-requests/:clientRequestId",
    component: _382c1634,
    name: "client-requests-clientRequestId"
  }, {
    path: "/custom-requests/:requestId",
    component: _4607e0a5,
    name: "custom-requests-requestId"
  }, {
    path: "/deposits/:depositId?",
    component: _5650fd7c,
    name: "deposits-depositId"
  }, {
    path: "/payment-orders/:paymentOrderId",
    component: _15ce1bca,
    name: "payment-orders-paymentOrderId"
  }, {
    path: "/payments/:paymentId",
    component: _3eaf364c,
    name: "payments-paymentId",
    children: [{
      path: "activity",
      component: _30011ea2,
      name: "payments-paymentId-activity"
    }, {
      path: "general",
      component: _0971f3a5,
      name: "payments-paymentId-general"
    }, {
      path: "operations",
      component: _a46dcb82,
      name: "payments-paymentId-operations"
    }]
  }, {
    path: "/profile-customers/:customerId",
    component: _8cded176,
    name: "profile-customers-customerId"
  }, {
    path: "/profiles/:profileId?",
    component: _8d2e8d5c,
    name: "profiles-profileId",
    children: [{
      path: "accounts",
      component: _35f1b09a,
      name: "profiles-profileId-accounts"
    }, {
      path: "activity",
      component: _0403a25c,
      name: "profiles-profileId-activity"
    }, {
      path: "card-orders",
      component: _075004f6,
      name: "profiles-profileId-card-orders"
    }, {
      path: "card-topup",
      component: _4bb455c0,
      name: "profiles-profileId-card-topup"
    }, {
      path: "cards",
      component: _d750ef34,
      name: "profiles-profileId-cards"
    }, {
      path: "cashback",
      component: _7e7ea067,
      name: "profiles-profileId-cashback"
    }, {
      path: "customers",
      component: _3e1966d8,
      name: "profiles-profileId-customers"
    }, {
      path: "esim-reissue",
      component: _3ad848d8,
      name: "profiles-profileId-esim-reissue"
    }, {
      path: "features",
      component: _27e766ec,
      name: "profiles-profileId-features"
    }, {
      path: "fees",
      component: _1b6d0f0c,
      name: "profiles-profileId-fees"
    }, {
      path: "forex-setup",
      component: _2a6574ef,
      name: "profiles-profileId-forex-setup"
    }, {
      path: "open-banking",
      component: _63e74b20,
      name: "profiles-profileId-open-banking"
    }, {
      path: "payment-orders",
      component: _2a025599,
      name: "profiles-profileId-payment-orders"
    }, {
      path: "payments",
      component: _f34b010c,
      name: "profiles-profileId-payments"
    }, {
      path: "requests",
      component: _1cb0a6de,
      name: "profiles-profileId-requests"
    }, {
      path: "restrictions",
      component: _7d23a6f4,
      name: "profiles-profileId-restrictions"
    }, {
      path: "savings",
      component: _4856b808,
      name: "profiles-profileId-savings"
    }, {
      path: "settings",
      component: _7a707d20,
      name: "profiles-profileId-settings"
    }, {
      path: "users",
      component: _91a156ea,
      name: "profiles-profileId-users"
    }, {
      path: "watchdog",
      component: _498e5a5a,
      name: "profiles-profileId-watchdog"
    }]
  }, {
    path: "/referral-campaigns/:campaignId",
    component: _4ae7f54e,
    name: "referral-campaigns-campaignId"
  }, {
    path: "/savings-accounts/:savingsAccountId?",
    component: _79c8ac41,
    name: "savings-accounts-savingsAccountId",
    children: [{
      path: "general",
      component: _47c4a49a,
      name: "savings-accounts-savingsAccountId-general"
    }, {
      path: "transactions",
      component: _50f60c93,
      name: "savings-accounts-savingsAccountId-transactions"
    }]
  }, {
    path: "/swift-message-orders/:swiftMessageOrderId",
    component: _b5c1b9ea,
    name: "swift-message-orders-swiftMessageOrderId"
  }, {
    path: "/swift-messages/:messageCloudReference",
    component: _6cf29192,
    name: "swift-messages-messageCloudReference"
  }, {
    path: "/banners/:bannerId/edit",
    component: _9f8eb47a,
    name: "banners-bannerId-edit"
  }, {
    path: "/card-orders/:orderId?/card",
    component: _2e97df10,
    name: "card-orders-orderId-card",
    children: [{
      path: "activity",
      component: _40dfdb44,
      name: "card-orders-orderId-card-activity"
    }, {
      path: "data",
      component: _3f41fcf9,
      name: "card-orders-orderId-card-data"
    }, {
      path: "delivery",
      component: _b1bf7e7a,
      name: "card-orders-orderId-card-delivery"
    }, {
      path: "limits",
      component: _025840a7,
      name: "card-orders-orderId-card-limits"
    }]
  }, {
    path: "/card-orders/:orderId?/edit",
    component: _e2da75ec,
    name: "card-orders-orderId-edit"
  }, {
    path: "/card-orders/:orderId?/order",
    component: _c36f5304,
    name: "card-orders-orderId-order",
    children: [{
      path: "activity",
      component: _310416b0,
      name: "card-orders-orderId-order-activity"
    }, {
      path: "data",
      component: _2c0e0b6a,
      name: "card-orders-orderId-order-data"
    }]
  }, {
    path: "/channel-setup/:license?/create",
    component: _221eb935,
    name: "channel-setup-license-create"
  }, {
    path: "/profile-customers/:customerId?/edit",
    component: _9d6de132,
    name: "profile-customers-customerId-edit"
  }, {
    path: "/profile-customers/:customerId?/view",
    component: _cdd9d2fc,
    children: [{
      path: "",
      component: _0ebd98f6,
      name: "profile-customers-customerId-view"
    }, {
      path: "activity",
      component: _c111c9a8,
      name: "profile-customers-customerId-view-activity"
    }, {
      path: "general",
      component: _78653ddb,
      name: "profile-customers-customerId-view-general"
    }]
  }, {
    path: "/referral-campaigns/:campaignId?/edit",
    component: _7a44e25a,
    name: "referral-campaigns-campaignId-edit"
  }, {
    path: "/swift-messages/:swiftMessageId?/reply",
    component: _b7d2e7b0,
    name: "swift-messages-swiftMessageId-reply"
  }, {
    path: "/swift-messages/:swiftMessageId?/v2",
    component: _62985531,
    name: "swift-messages-swiftMessageId-v2"
  }, {
    path: "/channel-setup/:license?/:currency",
    component: _466b3e0a,
    name: "channel-setup-license-currency",
    children: [{
      path: "activity",
      component: _6c5eeca4,
      name: "channel-setup-license-currency-index-activity"
    }, {
      path: "settings",
      component: _2b230bb8,
      name: "channel-setup-license-currency-index-settings"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
